/**
 * @flow
 * @relayHash a0122c4854f1df2f0a453b9874d640be
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HtmlTemplateCreateInput = {|
  name: string,
  tpl: string,
  categoryTemplateId: string,
  isDefault: boolean,
|};
export type CreateHtmlTemplateMutationVariables = {|
  data: HtmlTemplateCreateInput
|};
export type CreateHtmlTemplateMutationResponse = {|
  +createHtmlTemplate: {|
    +id: string
  |}
|};
export type CreateHtmlTemplateMutation = {|
  variables: CreateHtmlTemplateMutationVariables,
  response: CreateHtmlTemplateMutationResponse,
|};
*/


/*
mutation CreateHtmlTemplateMutation(
  $data: HtmlTemplateCreateInput!
) {
  createHtmlTemplate(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "HtmlTemplateCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createHtmlTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "HtmlTemplateModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateHtmlTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateHtmlTemplateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateHtmlTemplateMutation",
    "id": null,
    "text": "mutation CreateHtmlTemplateMutation(\n  $data: HtmlTemplateCreateInput!\n) {\n  createHtmlTemplate(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd450974bd19778f1ecfe75383f833893';
module.exports = node;
